export const formatCredentials = (credentials) => {
    if (Array.isArray(credentials)) {
        return credentials
            .map((c) => c.credentials)
            .filter(Boolean)
            .join(", ");
    }
    if (typeof credentials === "string") {
        // Check if it's a JSON string that needs parsing (defensive)
        if (credentials.startsWith("[") || credentials.startsWith("{")) {
            try {
                const parsed = JSON.parse(credentials);
                return formatCredentials(parsed);
            } catch (e) {
                return credentials;
            }
        }
        return credentials;
    }
    return "";
};
